import { useCookieConsent } from '@/contexts/CookieConsentContext';

/**
 * Placeholder for future marketing scripts (Meta Pixel, Google Ads).
 * Scripts load only when consent.marketing is true.
 */
export default function ConsentAwareMarketingScripts() {
  const { canUseMarketing } = useCookieConsent();

  if (!canUseMarketing()) {
    return null;
  }

  // Marketing vendors will be injected here when configured.
  return null;
}
